import { render, staticRenderFns } from "./Impuestos.vue?vue&type=template&id=5870528e"
import script from "./Impuestos.vue?vue&type=script&lang=js"
export * from "./Impuestos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports